import { render, staticRenderFns } from "./confim.vue?vue&type=template&id=b336c82e"
import script from "./confim.vue?vue&type=script&lang=js"
export * from "./confim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b336c82e')) {
      api.createRecord('b336c82e', component.options)
    } else {
      api.reload('b336c82e', component.options)
    }
    module.hot.accept("./confim.vue?vue&type=template&id=b336c82e", function () {
      api.rerender('b336c82e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/after/openReturn/confim.vue"
export default component.exports